import React from 'react';

function ProgressMessage({message}) {

    return (
        <h4>message</h4>
    )
}

export default ProgressMessage